import { RelatedIndex } from '../../related/RelatedPages';
export default function Page() { return <RelatedIndex locale="en" />; }
